export const GetAllTidePort = {
  status: 0,
  data: [
    {
      id: 8000001,
      cnname: '丹东',
      enname: 'DANDONG',
      cncountry: '中国',
      encountry: 'China',
      lat: 40.11667,
      lon: 124.4,
      timezone: '8',
      datumn: '在平均海面下150cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000002,
      cnname: '丹东新港',
      enname: 'DANDONGXINGANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 39.81667,
      lon: 124.15667,
      timezone: '8',
      datumn: '在平均海面下354cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000003,
      cnname: '石山子',
      enname: 'SHISHANZI',
      cncountry: '中国',
      encountry: 'China',
      lat: 39.96667,
      lon: 123.66667,
      timezone: '8',
      datumn: '在平均海面下200cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000004,
      cnname: '大鹿岛',
      enname: 'DALUDAO',
      cncountry: '中国',
      encountry: 'China',
      lat: 39.75,
      lon: 123.75,
      timezone: '8',
      datumn: '在平均海面下332cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000005,
      cnname: '小长山岛',
      enname: 'XIAOCHANGSHANDAO',
      cncountry: '中国',
      encountry: 'China',
      lat: 39.23,
      lon: 122.67833,
      timezone: '8',
      datumn: '在平均海面下232cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000006,
      cnname: '大窑湾',
      enname: 'DAYAOWAN NANDAQUAN',
      cncountry: '中国',
      encountry: 'China',
      lat: 39.01667,
      lon: 121.9,
      timezone: '8',
      datumn: '在平均海面下190cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000007,
      cnname: '大连',
      enname: 'DALIAN(LAOHUTAN)',
      cncountry: '中国',
      encountry: 'China',
      lat: 38.87167,
      lon: 121.67833,
      timezone: '8',
      datumn: '在平均海面下163cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000008,
      cnname: '旅顺新港',
      enname: 'LUSHUNXINGANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 38.8,
      lon: 121.13333,
      timezone: '8',
      datumn: '在平均海面下145cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000009,
      cnname: '金县',
      enname: 'JINXIAN',
      cncountry: '中国',
      encountry: 'China',
      lat: 39.05,
      lon: 121.53333,
      timezone: '8',
      datumn: '在平均海面下150cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000010,
      cnname: '葫芦套',
      enname: 'HULUTAO',
      cncountry: '中国',
      encountry: 'China',
      lat: 39.2725,
      lon: 121.6,
      timezone: '8',
      datumn: '在平均海面下130cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000011,
      cnname: '长兴岛',
      enname: 'CHANGXINGDAO',
      cncountry: '中国',
      encountry: 'China',
      lat: 39.47667,
      lon: 121.255,
      timezone: '8',
      datumn: '在平均海面下101cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000012,
      cnname: '鲅鱼圈',
      enname: 'BAYUQUAN',
      cncountry: '中国',
      encountry: 'China',
      lat: 40.28333,
      lon: 122.09167,
      timezone: '8',
      datumn: '在平均海面下194cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000013,
      cnname: '营口',
      enname: 'YINGKOU',
      cncountry: '中国',
      encountry: 'China',
      lat: 40.63333,
      lon: 122.15,
      timezone: '8',
      datumn: '在平均海面下200cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000014,
      cnname: '老北河口',
      enname: 'LAOBEIHEKOU',
      cncountry: '中国',
      encountry: 'China',
      lat: 40.96667,
      lon: 121.83333,
      timezone: '8',
      datumn: '在平均海面下209cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000015,
      cnname: '锦州港',
      enname: 'JINZHOUGANG(BIJIASHAN)',
      cncountry: '中国',
      encountry: 'China',
      lat: 40.8,
      lon: 121.06667,
      timezone: '8',
      datumn: '在平均海面下160cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000016,
      cnname: '菊花岛',
      enname: 'JUHUADAO',
      cncountry: '中国',
      encountry: 'China',
      lat: 40.48333,
      lon: 120.83333,
      timezone: '8',
      datumn: '在平均海面下142cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000017,
      cnname: '团山角',
      enname: 'TUANSHANJIAO',
      cncountry: '中国',
      encountry: 'China',
      lat: 40.23333,
      lon: 120.46667,
      timezone: '8',
      datumn: '在平均海面下76cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000018,
      cnname: '芷锚湾',
      enname: 'ZHIMAOWAN',
      cncountry: '中国',
      encountry: 'China',
      lat: 40.01167,
      lon: 119.92,
      timezone: '8',
      datumn: '在平均海面下75cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000019,
      cnname: '山海关',
      enname: 'SHANHAIGUAN',
      cncountry: '中国',
      encountry: 'China',
      lat: 39.97917,
      lon: 119.81667,
      timezone: '8',
      datumn: '在平均海面下104cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000020,
      cnname: '秦皇岛',
      enname: 'QINHUANGDAO',
      cncountry: '中国',
      encountry: 'China',
      lat: 39.90667,
      lon: 119.60333,
      timezone: '8',
      datumn: '在平均海面下91cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000021,
      cnname: '七里海',
      enname: 'QILIHAI(XINKAIKOU)',
      cncountry: '中国',
      encountry: 'China',
      lat: 39.58333,
      lon: 119.28333,
      timezone: '8',
      datumn: '在平均海面下130cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000022,
      cnname: '京唐港',
      enname: 'JINGTANGGANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 39.205,
      lon: 119.00833,
      timezone: '8',
      datumn: '在平均海面下148cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000023,
      cnname: '曹妃甸',
      enname: 'CAOFEIDIAN',
      cncountry: '中国',
      encountry: 'China',
      lat: 38.915,
      lon: 118.505,
      timezone: '8',
      datumn: '在平均海面下178cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000024,
      cnname: '塘沽',
      enname: 'TANGGU',
      cncountry: '中国',
      encountry: 'China',
      lat: 38.98333,
      lon: 117.78333,
      timezone: '8',
      datumn: '在平均海面下241cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000025,
      cnname: '岐口',
      enname: 'QIKOU',
      cncountry: '中国',
      encountry: 'China',
      lat: 38.6,
      lon: 117.51667,
      timezone: '8',
      datumn: '在平均海面下253cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000026,
      cnname: '埕口外海',
      enname: 'CHENGKOUWAIHAI',
      cncountry: '中国',
      encountry: 'China',
      lat: 38.45,
      lon: 118.43333,
      timezone: '8',
      datumn: '在平均海面下201cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000027,
      cnname: '黄骅港',
      enname: 'HUANGHUAGANG(YIQIMEIMATOU)',
      cncountry: '中国',
      encountry: 'China',
      lat: 38.325,
      lon: 117.88167,
      timezone: '8',
      datumn: '在平均海面下240cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000028,
      cnname: '东风港',
      enname: 'DONGFENGGANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 38.25,
      lon: 118.16667,
      timezone: '8',
      datumn: '在平均海面下166cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000029,
      cnname: '湾湾沟口',
      enname: 'WANWANGOUKOU',
      cncountry: '中国',
      encountry: 'China',
      lat: 38.18333,
      lon: 118.45,
      timezone: '8',
      datumn: '在平均海面下130cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000030,
      cnname: '东营港',
      enname: 'DONGYINGGANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 38.13833,
      lon: 119.03833,
      timezone: '8',
      datumn: '在平均海面下100cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000031,
      cnname: '潍坊港',
      enname: 'WEIFANGGANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 37.23333,
      lon: 119.18333,
      timezone: '8',
      datumn: '在平均海面下120cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000032,
      cnname: '莱州港',
      enname: 'LAIZHOUGANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 37.41667,
      lon: 119.93333,
      timezone: '8',
      datumn: '在平均海面下94cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000033,
      cnname: '龙口',
      enname: 'LONGKOU',
      cncountry: '中国',
      encountry: 'China',
      lat: 37.65167,
      lon: 120.315,
      timezone: '8',
      datumn: '在平均海面下70cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000034,
      cnname: '蓬莱',
      enname: 'PENGLAI',
      cncountry: '中国',
      encountry: 'China',
      lat: 37.83,
      lon: 120.73833,
      timezone: '8',
      datumn: '在平均海面下95cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000035,
      cnname: '南长山岛',
      enname: 'NANCHANGSHANDAO',
      cncountry: '中国',
      encountry: 'China',
      lat: 37.91667,
      lon: 120.7,
      timezone: '8',
      datumn: '在平均海面下92cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000036,
      cnname: '砣矶岛',
      enname: 'TUOJIDAO',
      cncountry: '中国',
      encountry: 'China',
      lat: 38.16667,
      lon: 120.75,
      timezone: '8',
      datumn: '在平均海面下89cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000037,
      cnname: '北隍城岛',
      enname: 'BEIHUANGCHENGDAO',
      cncountry: '中国',
      encountry: 'China',
      lat: 38.395,
      lon: 120.91833,
      timezone: '8',
      datumn: '在平均海面下100cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000038,
      cnname: '烟台',
      enname: 'YANTAI',
      cncountry: '中国',
      encountry: 'China',
      lat: 37.555,
      lon: 121.39167,
      timezone: '8',
      datumn: '在平均海面下147cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000039,
      cnname: '威海',
      enname: 'WEIHAI',
      cncountry: '中国',
      encountry: 'China',
      lat: 37.51333,
      lon: 122.13333,
      timezone: '8',
      datumn: '在平均海面下130cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000040,
      cnname: '成山角',
      enname: 'CHENGSHANJIAO',
      cncountry: '中国',
      encountry: 'China',
      lat: 37.38833,
      lon: 122.695,
      timezone: '8',
      datumn: '在平均海面下94cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000041,
      cnname: '石岛',
      enname: 'SHIDAO',
      cncountry: '中国',
      encountry: 'China',
      lat: 36.865,
      lon: 122.42,
      timezone: '8',
      datumn: '在平均海面下166cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000042,
      cnname: '张家埠',
      enname: 'ZHANGJIABU',
      cncountry: '中国',
      encountry: 'China',
      lat: 37.00917,
      lon: 122.16667,
      timezone: '8',
      datumn: '在平均海面下220cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000043,
      cnname: '乳山口',
      enname: 'RUSHANKOU',
      cncountry: '中国',
      encountry: 'China',
      lat: 36.8,
      lon: 121.483333,
      timezone: '8',
      datumn: '在平均海面下220cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000044,
      cnname: '千里岩',
      enname: 'QIANLIYAN',
      cncountry: '中国',
      encountry: 'China',
      lat: 36.26667,
      lon: 121.38333,
      timezone: '8',
      datumn: '在平均海面下183cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000045,
      cnname: '女岛港',
      enname: 'NUDAOGANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 36.36667,
      lon: 120.86667,
      timezone: '8',
      datumn: '在平均海面下220cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000046,
      cnname: '青岛',
      enname: 'QINGDAO',
      cncountry: '中国',
      encountry: 'China',
      lat: 36.08333,
      lon: 120.3,
      timezone: '8',
      datumn: '在平均海面下239cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000047,
      cnname: '黄岛',
      enname: 'HUANGDAO',
      cncountry: '中国',
      encountry: 'China',
      lat: 36.06267,
      lon: 120.20283,
      timezone: '8',
      datumn: '在平均海面下231cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000048,
      cnname: '董家口',
      enname: 'DONGJIAKOU',
      cncountry: '中国',
      encountry: 'China',
      lat: 35.6,
      lon: 119.76667,
      timezone: '8',
      datumn: '在平均海面下288cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000049,
      cnname: '日照港',
      enname: 'RIZHAOGANG(SHIJIUSUO)',
      cncountry: '中国',
      encountry: 'China',
      lat: 35.36667,
      lon: 119.56667,
      timezone: '8',
      datumn: '在平均海面下270cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000050,
      cnname: '岚山港',
      enname: 'LANSHANGANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 35.1,
      lon: 119.38333,
      timezone: '8',
      datumn: '在平均海面下310cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000051,
      cnname: '连云港',
      enname: 'LIANYUNGANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 34.78333,
      lon: 119.43333,
      timezone: '8',
      datumn: '在平均海面下290cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000052,
      cnname: '燕尾',
      enname: 'YANWEI',
      cncountry: '中国',
      encountry: 'China',
      lat: 34.475,
      lon: 119.785,
      timezone: '8',
      datumn: '在平均海面下278cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000053,
      cnname: '滨海港',
      enname: 'BINHAIGANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 34.26,
      lon: 120.29833,
      timezone: '8',
      datumn: '在平均海面下165cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000054,
      cnname: '射阳河口',
      enname: 'SHEYANGHEKOU',
      cncountry: '中国',
      encountry: 'China',
      lat: 33.81667,
      lon: 120.5,
      timezone: '8',
      datumn: '在平均海面下171cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000055,
      cnname: '新洋港',
      enname: 'XINYANGGANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 33.615,
      lon: 120.47833,
      timezone: '8',
      datumn: '在平均海面下200cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000056,
      cnname: '大丰港',
      enname: 'DAFENGGANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 33.283333,
      lon: 120.8,
      timezone: '8',
      datumn: '在平均海面下300cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000057,
      cnname: '弶港',
      enname: 'JIANGGANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 32.73333,
      lon: 120.86667,
      timezone: '8',
      datumn: '在平均海面下301cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000058,
      cnname: '洋口港',
      enname: 'YANGKOUGANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 32.515,
      lon: 121.42333,
      timezone: '8',
      datumn: '在平均海面下406cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000059,
      cnname: '吕四',
      enname: 'LUSI',
      cncountry: '中国',
      encountry: 'China',
      lat: 32.13333,
      lon: 121.61667,
      timezone: '8',
      datumn: '在平均海面下310cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000060,
      cnname: '天生港',
      enname: 'TIANSHENGGANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 32.03333,
      lon: 120.75,
      timezone: '8',
      datumn: '在平均海面下150cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000061,
      cnname: '佘山',
      enname: 'SHESHAN',
      cncountry: '中国',
      encountry: 'China',
      lat: 31.41667,
      lon: 122.23333,
      timezone: '8',
      datumn: '在平均海面下229cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000062,
      cnname: '崇明',
      enname: 'CHONGMING(NANBUZHEN)',
      cncountry: '中国',
      encountry: 'China',
      lat: 31.53333,
      lon: 121.63333,
      timezone: '8',
      datumn: '在平均海面下214cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000063,
      cnname: '中浚',
      enname: 'ZHONGJUN',
      cncountry: '中国',
      encountry: 'China',
      lat: 31.11667,
      lon: 121.9,
      timezone: '8',
      datumn: '在平均海面下225cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000064,
      cnname: '高桥',
      enname: 'GAOQIAO',
      cncountry: '中国',
      encountry: 'China',
      lat: 31.37667,
      lon: 121.56667,
      timezone: '8',
      datumn: '在平均海面下197cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000065,
      cnname: '吴淞',
      enname: 'WUSONG',
      cncountry: '中国',
      encountry: 'China',
      lat: 31.38333,
      lon: 121.5,
      timezone: '8',
      datumn: '在平均海面下202cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000066,
      cnname: '黄浦公园',
      enname: 'HUANGPUGONGYUAN',
      cncountry: '中国',
      encountry: 'China',
      lat: 31.24333,
      lon: 121.48667,
      timezone: '8',
      datumn: '在平均海面下154cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000067,
      cnname: '芦潮港',
      enname: 'LUCAOGANG(NANHUIZUI)',
      cncountry: '中国',
      encountry: 'China',
      lat: 30.84,
      lon: 121.845,
      timezone: '8',
      datumn: '在平均海面下267cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000068,
      cnname: '金山嘴',
      enname: 'JINSHANZUI',
      cncountry: '中国',
      encountry: 'China',
      lat: 30.73333,
      lon: 121.37167,
      timezone: '8',
      datumn: '在平均海面下307cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000069,
      cnname: '绿华山',
      enname: 'LUHUASHAN',
      cncountry: '中国',
      encountry: 'China',
      lat: 30.81667,
      lon: 122.6,
      timezone: '8',
      datumn: '在平均海面下263cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000070,
      cnname: '大戢山',
      enname: 'DAJISHAN',
      cncountry: '中国',
      encountry: 'China',
      lat: 30.81667,
      lon: 122.16667,
      timezone: '8',
      datumn: '在平均海面下254cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000071,
      cnname: '嵊山',
      enname: 'SHENGSHAN',
      cncountry: '中国',
      encountry: 'China',
      lat: 30.71667,
      lon: 122.8,
      timezone: '8',
      datumn: '在平均海面下240cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000072,
      cnname: '乍浦',
      enname: 'ZHAPU',
      cncountry: '中国',
      encountry: 'China',
      lat: 30.59333,
      lon: 121.10667,
      timezone: '8',
      datumn: '在平均海面下350cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000073,
      cnname: '澉浦',
      enname: 'GANPU',
      cncountry: '中国',
      encountry: 'China',
      lat: 30.37333,
      lon: 120.90833,
      timezone: '8',
      datumn: '在平均海面下414cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000074,
      cnname: '滩浒',
      enname: 'TANHU',
      cncountry: '中国',
      encountry: 'China',
      lat: 30.61667,
      lon: 121.61667,
      timezone: '8',
      datumn: '在平均海面下270cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000075,
      cnname: '海黄山',
      enname: 'HAIHUANGSHAN',
      cncountry: '中国',
      encountry: 'China',
      lat: 30.22283,
      lon: 121.51567,
      timezone: '8',
      datumn: '在平均海面下214cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000076,
      cnname: '长涂',
      enname: 'CHANGTU',
      cncountry: '中国',
      encountry: 'China',
      lat: 30.25,
      lon: 122.3,
      timezone: '8',
      datumn: '在平均海面下238cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000077,
      cnname: '岱山',
      enname: 'DAISHAN',
      cncountry: '中国',
      encountry: 'China',
      lat: 30.23333,
      lon: 122.18333,
      timezone: '8',
      datumn: '在平均海面下190cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000078,
      cnname: '西码头',
      enname: 'XIMATOU',
      cncountry: '中国',
      encountry: 'China',
      lat: 30.11817,
      lon: 122.14033,
      timezone: '8',
      datumn: '在平均海面下210cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000079,
      cnname: '沈家门',
      enname: 'SHENJIAMEN',
      cncountry: '中国',
      encountry: 'China',
      lat: 29.93333,
      lon: 122.3,
      timezone: '8',
      datumn: '在平均海面下252cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000080,
      cnname: '定海',
      enname: 'DINGHAI',
      cncountry: '中国',
      encountry: 'China',
      lat: 29.99333,
      lon: 122.03333,
      timezone: '8',
      datumn: '在平均海面下226cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000081,
      cnname: '沥港',
      enname: 'LIGANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 30.06667,
      lon: 121.85,
      timezone: '8',
      datumn: '在平均海面下205cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000082,
      cnname: '宁波',
      enname: 'NINGBO',
      cncountry: '中国',
      encountry: 'China',
      lat: 29.88333,
      lon: 121.55,
      timezone: '8',
      datumn: '在平均海面下180cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000083,
      cnname: '镇海',
      enname: 'ZHENHAI',
      cncountry: '中国',
      encountry: 'China',
      lat: 29.98333,
      lon: 121.73333,
      timezone: '8',
      datumn: '在平均海面下207cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000084,
      cnname: '北仑港',
      enname: 'BEILUNGANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 29.93442,
      lon: 121.84833,
      timezone: '8',
      datumn: '在平均海面下176cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000085,
      cnname: '崎头角',
      enname: 'QITOUJIAO',
      cncountry: '中国',
      encountry: 'China',
      lat: 29.907,
      lon: 122.1195,
      timezone: '8',
      datumn: '在平均海面下240cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000086,
      cnname: '梅山',
      enname: 'MEISHAN',
      cncountry: '中国',
      encountry: 'China',
      lat: 29.82217,
      lon: 122.00972,
      timezone: '8',
      datumn: '在平均海面下234cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000087,
      cnname: '西泽',
      enname: 'XIZE',
      cncountry: '中国',
      encountry: 'China',
      lat: 29.61667,
      lon: 121.83333,
      timezone: '8',
      datumn: '在平均海面下269cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000088,
      cnname: '石浦',
      enname: 'SHIPU',
      cncountry: '中国',
      encountry: 'China',
      lat: 29.21667,
      lon: 121.96667,
      timezone: '8',
      datumn: '在平均海面下307cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000089,
      cnname: '旗门港',
      enname: 'QIMEN〖KG*2〗GANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 29.15,
      lon: 121.46667,
      timezone: '8',
      datumn: '在平均海面下379cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000090,
      cnname: '健跳',
      enname: 'JIANTIAO',
      cncountry: '中国',
      encountry: 'China',
      lat: 29.03333,
      lon: 121.6,
      timezone: '8',
      datumn: '在平均海面下350cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000091,
      cnname: '鱼山',
      enname: 'YUSHAN',
      cncountry: '中国',
      encountry: 'China',
      lat: 28.88333,
      lon: 122.26667,
      timezone: '8',
      datumn: '在平均海面下251cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000092,
      cnname: '下大陈',
      enname: 'XIADACHEN',
      cncountry: '中国',
      encountry: 'China',
      lat: 28.455,
      lon: 121.905,
      timezone: '8',
      datumn: '在平均海面下299cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000093,
      cnname: '海门',
      enname: 'HAIMEN',
      cncountry: '中国',
      encountry: 'China',
      lat: 28.68617,
      lon: 121.45083,
      timezone: '8',
      datumn: '在平均海面下290cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000094,
      cnname: '海门港',
      enname: 'HAIMEN〖KG*2〗GANG(BAISHA)',
      cncountry: '中国',
      encountry: 'China',
      lat: 28.7,
      lon: 121.63333,
      timezone: '8',
      datumn: '在平均海面下331cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000095,
      cnname: '东门村',
      enname: 'DONGMENCUN',
      cncountry: '中国',
      encountry: 'China',
      lat: 28.33333,
      lon: 121.21667,
      timezone: '8',
      datumn: '在平均海面下430cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000096,
      cnname: '坎门',
      enname: 'KANMEN',
      cncountry: '中国',
      encountry: 'China',
      lat: 28.08333,
      lon: 121.28333,
      timezone: '8',
      datumn: '在平均海面下330cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000097,
      cnname: '大门岛',
      enname: 'DAMENDAO(HUANGDAAO)',
      cncountry: '中国',
      encountry: 'China',
      lat: 27.95,
      lon: 121.03833,
      timezone: '8',
      datumn: '在平均海面下363cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000098,
      cnname: '温州',
      enname: 'WENZHOU',
      cncountry: '中国',
      encountry: 'China',
      lat: 28.02833,
      lon: 120.625,
      timezone: '8',
      datumn: '在平均海面下296cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000099,
      cnname: '瑞安',
      enname: 'RUIAN',
      cncountry: '中国',
      encountry: 'China',
      lat: 27.785,
      lon: 120.62,
      timezone: '8',
      datumn: '在平均海面下310cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000100,
      cnname: '南麂山',
      enname: 'NANJISHAN',
      cncountry: '中国',
      encountry: 'China',
      lat: 27.465,
      lon: 121.06317,
      timezone: '8',
      datumn: '在平均海面下315cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000101,
      cnname: '三沙',
      enname: 'SANSHA',
      cncountry: '中国',
      encountry: 'China',
      lat: 26.91667,
      lon: 120.21667,
      timezone: '8',
      datumn: '在平均海面下349cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000102,
      cnname: '赛岐',
      enname: 'SAIQI',
      cncountry: '中国',
      encountry: 'China',
      lat: 26.96667,
      lon: 119.66667,
      timezone: '8',
      datumn: '在平均海面下417cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000103,
      cnname: '漳湾',
      enname: 'BANGMEN',
      cncountry: '中国',
      encountry: 'China',
      lat: 26.75,
      lon: 119.616667,
      timezone: '8',
      datumn: '在平均海面下482cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000104,
      cnname: '罗源迹头',
      enname: 'LUOYUANJITOU',
      cncountry: '中国',
      encountry: 'China',
      lat: 26.46667,
      lon: 119.68333,
      timezone: '8',
      datumn: '在平均海面下406cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000105,
      cnname: '北茭',
      enname: 'HUANGQI',
      cncountry: '中国',
      encountry: 'China',
      lat: 26.366667,
      lon: 119.933333,
      timezone: '8',
      datumn: '在平均海面下369cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000106,
      cnname: '马尾',
      enname: 'MAWEI',
      cncountry: '中国',
      encountry: 'China',
      lat: 25.96283,
      lon: 119.46638,
      timezone: '8',
      datumn: '在平均海面下296cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000107,
      cnname: '福清湾',
      enname: 'FUQINGWAN(SONGXIAGANG)',
      cncountry: '中国',
      encountry: 'China',
      lat: 25.68333,
      lon: 119.58333,
      timezone: '8',
      datumn: '在平均海面下394cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000108,
      cnname: '竹屿',
      enname: 'ZHUYU',
      cncountry: '中国',
      encountry: 'China',
      lat: 25.51667,
      lon: 119.73333,
      timezone: '8',
      datumn: '在平均海面下391cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000109,
      cnname: '郎官',
      enname: 'LANGGUAN',
      cncountry: '中国',
      encountry: 'China',
      lat: 25.56667,
      lon: 119.3,
      timezone: '8',
      datumn: '在平均海面下427cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000110,
      cnname: '闽江口-川石',
      enname: 'MINJIANGKOU(CHUANSHI)',
      cncountry: '中国',
      encountry: 'China',
      lat: 26.13277,
      lon: 119.65695,
      timezone: '8',
      datumn: '在平均海面下353cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000111,
      cnname: '闽江口-琯头',
      enname: 'MINJIANGKOU(GUANTOU)',
      cncountry: '中国',
      encountry: 'China',
      lat: 26.13,
      lon: 119.55667,
      timezone: '8',
      datumn: '在平均海面下325cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000112,
      cnname: '平潭',
      enname: 'PINGTAN',
      cncountry: '中国',
      encountry: 'China',
      lat: 25.45833,
      lon: 119.84833,
      timezone: '8',
      datumn: '在平均海面下403cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000113,
      cnname: '三江口',
      enname: 'SANJIANGKOU',
      cncountry: '中国',
      encountry: 'China',
      lat: 25.41667,
      lon: 119.11667,
      timezone: '8',
      datumn: '在平均海面下427cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000114,
      cnname: '石城',
      enname: 'XIUYU',
      cncountry: '中国',
      encountry: 'China',
      lat: 25.266667,
      lon: 119.366667,
      timezone: '8',
      datumn: '在平均海面下407cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000115,
      cnname: '秀屿',
      enname: 'TIWU',
      cncountry: '中国',
      encountry: 'China',
      lat: 25.15,
      lon: 119.016667,
      timezone: '8',
      datumn: '在平均海面下410cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000116,
      cnname: '崇武',
      enname: 'CHONGWU',
      cncountry: '中国',
      encountry: 'China',
      lat: 24.87667,
      lon: 118.95833,
      timezone: '8',
      datumn: '在平均海面下351cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000117,
      cnname: '后渚',
      enname: 'HOUZHU',
      cncountry: '中国',
      encountry: 'China',
      lat: 24.9,
      lon: 118.66667,
      timezone: '8',
      datumn: '在平均海面下360cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000118,
      cnname: '泉州',
      enname: 'QUANZHOU(SHIHU)',
      cncountry: '中国',
      encountry: 'China',
      lat: 24.81667,
      lon: 118.7,
      timezone: '8',
      datumn: '在平均海面下366cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000119,
      cnname: '深沪港',
      enname: 'SHENHUGANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 24.63167,
      lon: 118.675,
      timezone: '8',
      datumn: '在平均海面下333cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000120,
      cnname: '围头',
      enname: 'WEITOU',
      cncountry: '中国',
      encountry: 'China',
      lat: 24.51667,
      lon: 118.56667,
      timezone: '8',
      datumn: '在平均海面下322cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000121,
      cnname: '石井',
      enname: 'SHIJING',
      cncountry: '中国',
      encountry: 'China',
      lat: 24.63412,
      lon: 118.4295,
      timezone: '8',
      datumn: '在平均海面下336cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000122,
      cnname: '厦门',
      enname: 'XIAMEN',
      cncountry: '中国',
      encountry: 'China',
      lat: 24.44833,
      lon: 118.07,
      timezone: '8',
      datumn: '在平均海面下328cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000123,
      cnname: '将军澳',
      enname: 'JIANGJUNAO',
      cncountry: '中国',
      encountry: 'China',
      lat: 24.03333,
      lon: 117.9,
      timezone: '8',
      datumn: '在平均海面下273cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000124,
      cnname: '石码',
      enname: 'SHIMA',
      cncountry: '中国',
      encountry: 'China',
      lat: 24.45083,
      lon: 117.81767,
      timezone: '8',
      datumn: '在平均海面下290cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000125,
      cnname: '东山',
      enname: 'DONGSHAN',
      cncountry: '中国',
      encountry: 'China',
      lat: 23.74333,
      lon: 117.52333,
      timezone: '8',
      datumn: '在平均海面下216cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000126,
      cnname: '马公',
      enname: 'MAGONG',
      cncountry: '中国',
      encountry: 'China',
      lat: 23.55,
      lon: 119.56667,
      timezone: '8',
      datumn: '在平均海面下160cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000127,
      cnname: '基隆',
      enname: 'JILONG',
      cncountry: '中国',
      encountry: 'China',
      lat: 25.15,
      lon: 121.73333,
      timezone: '8',
      datumn: '在平均海面下60cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000128,
      cnname: '高雄',
      enname: 'GAOXIONG',
      cncountry: '中国',
      encountry: 'China',
      lat: 22.6,
      lon: 120.28333,
      timezone: '8',
      datumn: '在平均海面下60cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000129,
      cnname: '南澳岛（云澳）',
      enname: 'NANAODAO(YUNAO)',
      cncountry: '中国',
      encountry: 'China',
      lat: 23.4,
      lon: 117.1,
      timezone: '8',
      datumn: '在平均海面下145cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000130,
      cnname: '潮州港',
      enname: 'CHAOZHOU〖KG*2〗GANG(SANBAIMEN)',
      cncountry: '中国',
      encountry: 'China',
      lat: 23.6,
      lon: 116.96667,
      timezone: '8',
      datumn: '在平均海面下178cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000131,
      cnname: '汕头',
      enname: 'SHANTOU',
      cncountry: '中国',
      encountry: 'China',
      lat: 23.33333,
      lon: 116.73333,
      timezone: '8',
      datumn: '在平均海面下137cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000700,
      cnname: '神泉港',
      enname: 'SHENQUANGANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 22.9271,
      lon: 116.243,
      timezone: '8',
      datumn: '在平均海面下137cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000132,
      cnname: '海门-广东',
      enname: 'HAIMEN(GUANGDONG)',
      cncountry: '中国',
      encountry: 'China',
      lat: 23.183333,
      lon: 116.616667,
      timezone: '8',
      datumn: '在平均海面下111cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000133,
      cnname: '甲子',
      enname: 'JIAZI',
      cncountry: '中国',
      encountry: 'China',
      lat: 22.81667,
      lon: 116.1,
      timezone: '8',
      datumn: '在平均海面下90cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000134,
      cnname: '汕尾',
      enname: 'SHANWEI',
      cncountry: '中国',
      encountry: 'China',
      lat: 22.76667,
      lon: 115.36667,
      timezone: '8',
      datumn: '在平均海面下100cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000135,
      cnname: '马鞭洲',
      enname: 'MABIANZHOU(GUANGSHIHUA)',
      cncountry: '中国',
      encountry: 'China',
      lat: 22.66667,
      lon: 114.65,
      timezone: '8',
      datumn: '在平均海面下116cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000136,
      cnname: '惠州港',
      enname: 'HUIZHOUGANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 22.695,
      lon: 114.565,
      timezone: '8',
      datumn: '在平均海面下135cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000137,
      cnname: '大亚湾',
      enname: 'DAYAWAN',
      cncountry: '中国',
      encountry: 'China',
      lat: 22.59167,
      lon: 114.53417,
      timezone: '8',
      datumn: '在平均海面下120cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000138,
      cnname: '大鹏湾',
      enname: 'DAPENGWAN(YANTIANGANG)',
      cncountry: '中国',
      encountry: 'China',
      lat: 22.58833,
      lon: 114.27833,
      timezone: '8',
      datumn: '在平均海面下116cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000139,
      cnname: '香港',
      enname: 'XIANGGANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 22.3,
      lon: 114.16667,
      timezone: '8',
      datumn: '在平均海面下138cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000140,
      cnname: '蛇口',
      enname: 'SHEKOU(CHIWAN)',
      cncountry: '中国',
      encountry: 'China',
      lat: 22.45,
      lon: 113.88333,
      timezone: '8',
      datumn: '在平均海面下152cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000141,
      cnname: '桂山岛',
      enname: 'GUISHANDAO',
      cncountry: '中国',
      encountry: 'China',
      lat: 22.13333,
      lon: 113.81667,
      timezone: '8',
      datumn: '在平均海面下140cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000142,
      cnname: '内伶仃岛',
      enname: 'NEILINGDING',
      cncountry: '中国',
      encountry: 'China',
      lat: 22.42333,
      lon: 113.79917,
      timezone: '8',
      datumn: '在平均海面下170cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000143,
      cnname: '舢舨洲',
      enname: 'SHANBANZHOU',
      cncountry: '中国',
      encountry: 'China',
      lat: 22.71667,
      lon: 113.66667,
      timezone: '8',
      datumn: '在平均海面下190cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000144,
      cnname: '深圳机场',
      enname: 'SHENZHENJICHANG(YOUMATOU)',
      cncountry: '中国',
      encountry: 'China',
      lat: 22.63333,
      lon: 113.8,
      timezone: '8',
      datumn: '在平均海面下170cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000145,
      cnname: '南沙',
      enname: 'NANSHA(SHUINIUTOU)',
      cncountry: '中国',
      encountry: 'China',
      lat: 22.7461,
      lon: 113.5611,
      timezone: '8',
      datumn: '在平均海面下140cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000146,
      cnname: '海沁',
      enname: 'HAIQIN',
      cncountry: '中国',
      encountry: 'China',
      lat: 22.96667,
      lon: 113.53333,
      timezone: '8',
      datumn: '在平均海面下176cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000147,
      cnname: '黄埔',
      enname: 'HUANGPU',
      cncountry: '中国',
      encountry: 'China',
      lat: 23.09167,
      lon: 113.45833,
      timezone: '8',
      datumn: '在平均海面下155cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000148,
      cnname: '广州',
      enname: 'GUANGZHOU',
      cncountry: '中国',
      encountry: 'China',
      lat: 23.06667,
      lon: 113.26667,
      timezone: '8',
      datumn: '在平均海面下134cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000149,
      cnname: '北街',
      enname: 'BEIJIE',
      cncountry: '中国',
      encountry: 'China',
      lat: 22.60388,
      lon: 113.11467,
      timezone: '8',
      datumn: '在平均海面下60cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000150,
      cnname: '横门',
      enname: 'HENGMEN',
      cncountry: '中国',
      encountry: 'China',
      lat: 22.575,
      lon: 113.51833,
      timezone: '8',
      datumn: '在平均海面下123cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000151,
      cnname: '珠海-香洲',
      enname: 'ZHUHAI(XIANGZHOU)',
      cncountry: '中国',
      encountry: 'China',
      lat: 22.28333,
      lon: 113.58333,
      timezone: '8',
      datumn: '在平均海面下150cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000152,
      cnname: '珠海-九洲港',
      enname: 'ZHUHAI(JIUZHOUGANG)',
      cncountry: '中国',
      encountry: 'China',
      lat: 22.2425,
      lon: 113.583617,
      timezone: '8',
      datumn: '在平均海面下139cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000153,
      cnname: '澳门',
      enname: 'AOMEN',
      cncountry: '中国',
      encountry: 'China',
      lat: 22.21797,
      lon: 113.55333,
      timezone: '8',
      datumn: '在平均海面下202cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000154,
      cnname: '东澳岛',
      enname: 'DONGAODAO',
      cncountry: '中国',
      encountry: 'China',
      lat: 22.01667,
      lon: 113.7,
      timezone: '8',
      datumn: '在平均海面下130cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000155,
      cnname: '大万山',
      enname: 'DAWANSHAN',
      cncountry: '中国',
      encountry: 'China',
      lat: 21.93333,
      lon: 113.71667,
      timezone: '8',
      datumn: '在平均海面下126cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000156,
      cnname: '灯笼山',
      enname: 'DENGLONGSHAN',
      cncountry: '中国',
      encountry: 'China',
      lat: 22.23333,
      lon: 113.4,
      timezone: '8',
      datumn: '在平均海面下119cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000157,
      cnname: '三灶岛',
      enname: 'SANZAODAO',
      cncountry: '中国',
      encountry: 'China',
      lat: 22.03333,
      lon: 113.4,
      timezone: '8',
      datumn: '在平均海面下140cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000158,
      cnname: '珠海港',
      enname: 'ZHUHAIGANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 21.94556,
      lon: 113.23111,
      timezone: '8',
      datumn: '在平均海面下148cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000159,
      cnname: '横山',
      enname: 'HENGSHAN',
      cncountry: '中国',
      encountry: 'China',
      lat: 22.33333,
      lon: 113.18333,
      timezone: '8',
      datumn: '在平均海面下95cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000160,
      cnname: '井岸',
      enname: 'JINGAN(BAIJIAO)',
      cncountry: '中国',
      encountry: 'China',
      lat: 22.21667,
      lon: 113.3,
      timezone: '8',
      datumn: '在平均海面下107cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000161,
      cnname: '上川岛',
      enname: 'SHANGCHUANDAO(SANZHOUWAN)',
      cncountry: '中国',
      encountry: 'China',
      lat: 21.75,
      lon: 112.76667,
      timezone: '8',
      datumn: '在平均海面下158cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000162,
      cnname: '北津',
      enname: 'BEIJIN',
      cncountry: '中国',
      encountry: 'China',
      lat: 21.8,
      lon: 112.01667,
      timezone: '8',
      datumn: '在平均海面下150cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000163,
      cnname: '海陵山岛',
      enname: 'HAILINGSHANDAO(ZHAPO)',
      cncountry: '中国',
      encountry: 'China',
      lat: 21.58333,
      lon: 111.81667,
      timezone: '8',
      datumn: '在平均海面下170cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000164,
      cnname: '电白',
      enname: 'DIANBAI',
      cncountry: '中国',
      encountry: 'China',
      lat: 21.5,
      lon: 111.26667,
      timezone: '8',
      datumn: '在平均海面下174cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000165,
      cnname: '博贺',
      enname: 'BOHE',
      cncountry: '中国',
      encountry: 'China',
      lat: 21.48333,
      lon: 111.23333,
      timezone: '8',
      datumn: '在平均海面下170cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000166,
      cnname: '西葛',
      enname: 'XIGE',
      cncountry: '中国',
      encountry: 'China',
      lat: 21.4661,
      lon: 111.09694,
      timezone: '8',
      datumn: '在平均海面下180cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000167,
      cnname: '茂石化',
      enname: 'MAOSHIHUA(SHUIDONGGANG)',
      cncountry: '中国',
      encountry: 'China',
      lat: 21.478333,
      lon: 111.073333,
      timezone: '8',
      datumn: '在平均海面下197cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000168,
      cnname: '硇洲岛',
      enname: 'NAOZHOUDAO(BEIGANG)',
      cncountry: '中国',
      encountry: 'China',
      lat: 20.9,
      lon: 110.55,
      timezone: '8',
      datumn: '在平均海面下190cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000169,
      cnname: '湛江',
      enname: 'ZHANJIANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 21.16667,
      lon: 110.4,
      timezone: '8',
      datumn: '在平均海面下220cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000170,
      cnname: '下港',
      enname: 'XIAGANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 20.51667,
      lon: 110.53333,
      timezone: '8',
      datumn: '在平均海面下120cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000171,
      cnname: '海安',
      enname: 'HAIAN',
      cncountry: '中国',
      encountry: 'China',
      lat: 20.22833,
      lon: 110.12667,
      timezone: '8',
      datumn: '在平均海面下170cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000172,
      cnname: '流沙',
      enname: 'LIUSHA',
      cncountry: '中国',
      encountry: 'China',
      lat: 20.44639,
      lon: 109.99222,
      timezone: '8',
      datumn: '在平均海面下200cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000173,
      cnname: '乌石',
      enname: 'WUSHI',
      cncountry: '中国',
      encountry: 'China',
      lat: 20.55,
      lon: 109.83333,
      timezone: '8',
      datumn: '在平均海面下190cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000174,
      cnname: '下泊',
      enname: 'XIABO',
      cncountry: '中国',
      encountry: 'China',
      lat: 21.26667,
      lon: 109.76667,
      timezone: '8',
      datumn: '在平均海面下280cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000175,
      cnname: '东沙岛',
      enname: 'DONGSHADAO(DONGSHA〖KG*2〗QUNDAO)',
      cncountry: '中国',
      encountry: 'China',
      lat: 20.7,
      lon: 116.71667,
      timezone: '8',
      datumn: '在平均海面下70cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000176,
      cnname: '海口',
      enname: 'HAIKOU(XIUYING)',
      cncountry: '中国',
      encountry: 'China',
      lat: 20.025,
      lon: 110.276667,
      timezone: '8',
      datumn: '在平均海面下150cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000177,
      cnname: '铺前',
      enname: 'PUQIAN',
      cncountry: '中国',
      encountry: 'China',
      lat: 20.03305,
      lon: 110.572,
      timezone: '8',
      datumn: '在平均海面下130cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000178,
      cnname: '清澜',
      enname: 'QINGLAN',
      cncountry: '中国',
      encountry: 'China',
      lat: 19.563333,
      lon: 110.821667,
      timezone: '8',
      datumn: '在平均海面下95cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000179,
      cnname: '博鳌',
      enname: 'BOAO',
      cncountry: '中国',
      encountry: 'China',
      lat: 19.19833,
      lon: 110.60667,
      timezone: '8',
      datumn: '在平均海面下90cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000180,
      cnname: '新村',
      enname: 'XINCUN',
      cncountry: '中国',
      encountry: 'China',
      lat: 18.415,
      lon: 109.97055,
      timezone: '8',
      datumn: '在平均海面下90cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000181,
      cnname: '牙笼港',
      enname: 'YALONGGANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 18.22212,
      lon: 109.695,
      timezone: '8',
      datumn: '在平均海面下90cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000182,
      cnname: '三亚',
      enname: 'SANYA',
      cncountry: '中国',
      encountry: 'China',
      lat: 18.245167,
      lon: 109.4975,
      timezone: '8',
      datumn: '在平均海面下90cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000183,
      cnname: '莺歌海',
      enname: 'YINGGEHAI',
      cncountry: '中国',
      encountry: 'China',
      lat: 18.505,
      lon: 108.688333,
      timezone: '8',
      datumn: '在平均海面下74cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000184,
      cnname: '东方',
      enname: 'DONGFANG(BASUO)',
      cncountry: '中国',
      encountry: 'China',
      lat: 19.10667,
      lon: 108.625,
      timezone: '8',
      datumn: '在平均海面下145cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000185,
      cnname: '洋浦',
      enname: 'YANGPU',
      cncountry: '中国',
      encountry: 'China',
      lat: 19.73195,
      lon: 109.1875,
      timezone: '8',
      datumn: '在平均海面下195cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000186,
      cnname: '新盈',
      enname: 'XINYING',
      cncountry: '中国',
      encountry: 'China',
      lat: 19.9,
      lon: 109.51667,
      timezone: '8',
      datumn: '在平均海面下205cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000187,
      cnname: '马村港',
      enname: 'MACUNGANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 19.95972,
      lon: 110.02388,
      timezone: '8',
      datumn: '在平均海面下174cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000188,
      cnname: '永兴岛',
      enname: '',
      cncountry: '中国',
      encountry: 'China',
      lat: 16.83333,
      lon: 112.33333,
      timezone: '8',
      datumn: '',
      tidetype: '正规日潮',
    },
    {
      id: 8000189,
      cnname: '双子礁',
      enname: '',
      cncountry: '中国',
      encountry: 'China',
      lat: 11.45,
      lon: 114.31667,
      timezone: '8',
      datumn: '',
      tidetype: '正规日潮',
    },
    {
      id: 8000190,
      cnname: '永暑礁',
      enname: '',
      cncountry: '中国',
      encountry: 'China',
      lat: 9.55,
      lon: 112.88333,
      timezone: '8',
      datumn: '',
      tidetype: '正规日潮',
    },
    {
      id: 8000191,
      cnname: '铁山港',
      enname: 'TIESHANGANG(SHITOUBU)',
      cncountry: '中国',
      encountry: 'China',
      lat: 21.58333,
      lon: 109.56667,
      timezone: '8',
      datumn: '在平均海面下300cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000192,
      cnname: '涠洲岛',
      enname: 'WEIZHOUDAO',
      cncountry: '中国',
      encountry: 'China',
      lat: 21.01667,
      lon: 109.11667,
      timezone: '8',
      datumn: '在平均海面下240cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000193,
      cnname: '北海',
      enname: 'BEIHAI',
      cncountry: '中国',
      encountry: 'China',
      lat: 21.46667,
      lon: 109.05,
      timezone: '8',
      datumn: '在平均海面下255cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000194,
      cnname: '龙门',
      enname: 'LONGMEN',
      cncountry: '中国',
      encountry: 'China',
      lat: 21.75,
      lon: 108.55,
      timezone: '8',
      datumn: '在平均海面下250cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000195,
      cnname: '企沙',
      enname: 'QISHA',
      cncountry: '中国',
      encountry: 'China',
      lat: 21.58333,
      lon: 108.48333,
      timezone: '8',
      datumn: '在平均海面下230cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000196,
      cnname: '炮台角',
      enname: 'PAOTAIJIAO',
      cncountry: '中国',
      encountry: 'China',
      lat: 21.56667,
      lon: 108.38333,
      timezone: '8',
      datumn: '在平均海面下230cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000197,
      cnname: '防城港',
      enname: 'FANGCHENGGANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 21.6,
      lon: 108.33333,
      timezone: '8',
      datumn: '在平均海面下230cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000198,
      cnname: '珍珠港',
      enname: 'ZHENZHUGANG',
      cncountry: '中国',
      encountry: 'China',
      lat: 21.51667,
      lon: 108.21667,
      timezone: '8',
      datumn: '在平均海面下230cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000199,
      cnname: '白龙尾',
      enname: 'BAILONGWEI',
      cncountry: '中国',
      encountry: 'China',
      lat: 21.5,
      lon: 108.23333,
      timezone: '8',
      datumn: '在平均海面下282cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000484,
      cnname: '钓鱼岛',
      enname: 'DIAOYUDAO',
      cncountry: '中国',
      encountry: 'China',
      lat: 25.73333,
      lon: 123.46667,
      timezone: '8',
      datumn: '在平均海面下105cm',
      tidetype: '正规日潮',
    },
    {
      id: 8000485,
      cnname: '中沙群岛－黄岩岛',
      enname: '',
      cncountry: '中国',
      encountry: 'China',
      lat: 15.11667,
      lon: 117.85,
      timezone: '8',
      datumn: '',
      tidetype: '正规日潮',
    },
  ],
}
